import Button from 'components/Button';
import { ProfileChipContainer } from 'components/Chips/ChipContainers';
import InterviewStatusChip from 'components/Chips/InterviewStatusChip';
import { PageBack, PageHeadContainer, PageTitle } from 'components/PageHead';
import { FC, useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import Interview from 'types/Interview';
import { getLocaleDate, getLocaleTime } from 'utils/time';

const PageBackContainer = styled.div`
  margin-bottom: auto;
  font-size: 1.5rem;
`;
const TitleContainer = styled.div``;

const NameEmail = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0.5rem;
`;
const Email = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: var(--gray-500);
  div:first-child {
    margin-right: 0.8rem;
  }
`;

type Props = {
  interview: Interview | undefined;
  title: string;
  backTo: string;
  variant: 'admin' | 'mentee' | 'mentor';
};
const InterviewHead: FC<Props> = ({ interview, title, backTo, variant }) => {
  const [searchParams] = useSearchParams();

  const to: string = useMemo(() => {
    return searchParams.get('from') || backTo;
  }, [backTo, searchParams]);

  return (
    <>
      <PageHeadContainer>
        <PageTitle>
          <PageBackContainer>
            <PageBack href={to} />
          </PageBackContainer>
          <TitleContainer>
            <NameEmail>
              <h1>{title}</h1>
            </NameEmail>
            <ProfileChipContainer>
              {interview && (
                <InterviewStatusChip interview={interview} variant={variant} />
              )}
              <Email>
                <div>&bull;</div>
                {interview?.date &&
                  `${getLocaleDate(interview.date)} - ${getLocaleTime(
                    interview.date,
                  )}`}
              </Email>
            </ProfileChipContainer>
          </TitleContainer>
        </PageTitle>
        {variant === 'mentor' && interview?.artificial && (
          <Link
            to={`edit?from=${window.location.pathname}${window.location.search}`}
          >
            <Button color="primary">Modifier les détails de l'entretien</Button>
          </Link>
        )}
      </PageHeadContainer>
    </>
  );
};

export default InterviewHead;
